import React from "react";
import { rem } from "polished";
import styled, { css } from "styled-components";
import Checkbox from "./Checkbox";

const El = styled.div`
	font-family: sans-serif;
	position: relative;
	padding-top: ${rem(16)};
	border-top: 1px solid #dbdbdb;
	margin-top: ${rem(30)};
	margin-bottom: ${rem(100)};
`;

const Title = styled.h3`
	font-size: ${rem(24)};
	line-height: 1.3;
	font-weight: 400;

	em {
		color: #9e3f3a;
	}
`;

const Text = styled.div`
	font-size: ${rem(13)};
	line-height: 1.5;
	color: #5c5e62;
	padding-top: ${rem(10)};
	margin-bottom: ${rem(16)};

	& > * + * {
		margin-top: ${rem(10)};
	}
`;

const Highlight = styled.div`
	font-weight: 800;
	font-size: ${rem(11)};
	line-height: ${rem(18)};
	text-transform: uppercase;
	padding: 0 ${rem(6)};
	background: #fff;
	color: #fff;
	display: inline-block;
	position: relative;
	z-index: 1;
	margin-bottom: ${rem(5)};

	svg {
		position: absolute;
		left: 0;
		height: 100%;
		z-index: -1;
		margin-top: -1px;
	}
`;

const DiscountBubble = styled.div`
	width: ${rem(47)};
	height: ${rem(47)};
	background: #9e3f3a;
	position: absolute;
	right: 0;
	top: ${rem(15)};
	border-radius: 999em;
	font-size: ${rem(9)};
	text-transform: uppercase;
	color: #fff;
	display: flex;
	text-align: center;
	align-items: center;
	justify-content: center;

	strong {
		display: block;
		font-size: ${rem(18)};
		font-weight: 800;
		margin-top: ${rem(-2)};
		margin-bottom: ${rem(2)};
	}
`;

const HeadingSection = styled.div`
	padding-right: ${rem(50)};
`;

const LimitedOfferIntro = ({
	data,
	isActive,
	setActive,
	checkBoxesData,
	setModelId,
	setmodelNodes,
}) => (
	<El>
		<HeadingSection>
			<Highlight>
				Limited offer
				<svg
					width="110"
					height="18"
					viewBox="0 0 110 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0 1.5C0 0.671573 0.671573 0 1.5 0H96.4604C97.5843 0 98.6398 0.53969 99.2978 1.45078L109.532 15.6218C110.249 16.6138 109.54 18 108.316 18H98.25H1.5C0.671575 18 0 17.3284 0 16.5V1.5Z"
						fill="#9E3F3A"
					/>
				</svg>
			</Highlight>

			<Title dangerouslySetInnerHTML={{ __html: data.title }} />

			<DiscountBubble>
				<span>
					save
					<br />
					<strong>{data.discount}%</strong>
				</span>
			</DiscountBubble>
		</HeadingSection>

		<Text dangerouslySetInnerHTML={{ __html: data.text }} />

		{checkBoxesData.map((item, index) => (
			<Checkbox
				key={index}
				onChange={() => {
					setActive(item.id);
					setModelId(item.modelId);
					if (item.modelNodes) {
						setmodelNodes(item.modelNodes);
					} else {
						setmodelNodes("");
					}
				}}
				isChecked={isActive === item.id}
				showStock={true}
				showSale={true}
				{...item}
			/>
		))}
	</El>
);

export default LimitedOfferIntro;
